import React, { useState, useEffect } from "react"
import "./Navbar.css"
import { useTranslation } from "react-i18next";
import { AbstructVar } from "../../general/general-component/abstruct-component/AbstructVar";
import useClickOutside from "../../../useClickOutside";
import Notify from "./Noyify";
import avatar from '../../../assets/images/user-avater.png';
import SearchBar from "./SearchBar";
import { loadProfileDetails } from "../../../store/Actions/ActionProfile";
import { useSelectorCustom } from "../../general/general-component/abstruct-component/useSelectorCustom";
import Calendar from "../calendar";
const Navbar = ({ openSidebar, toggleSwitch }) => {
    let { langLocal, mode,navigate,dispatch } = AbstructVar()
    const [t, i18n] = useTranslation();
    const [langPop, setlangPop] = useState(false);
    const [openCalendar, setOpenCalendar] = useState(false);
    const [notify, setNotify] = useState(false);
    const { profileDetails, loadingProfileDetails } = useSelectorCustom()
    let domNode = useClickOutside(() => {
        setlangPop(false);
    });
    useEffect(() => {
        //dispatch(loadProfileDetails())
        i18n.changeLanguage(localStorage.getItem('pentalensLang'));
    }, []);
    const navigateToProfile =()=>{
        navigate('./profile')
    }
    return (
        <>
            <nav className="navbar" dir={langLocal == "ar" ? "rtl" : "ltr"}>
                <div className="nav_icon" onClick={() => openSidebar()}>
                    <i className="fa fa-bars"></i>
                </div>

                <div className="navbar_left">
                    <SearchBar />
                </div>
                {/*<input type="color" />*/}

                <div className="navbar_right">

                    {
                        notify && (
                            <Notify notify={notify} setNotify={setNotify} langLocal={langLocal} />
                        )
                    }
                    {
                        openCalendar &&(
                            <Calendar open={openCalendar} setOpen={setOpenCalendar} />
                        )
                    }

                    <i className={`fa fa-envelope globe ${langLocal === 'ar' ? "margin_right_20" : "margin_left_20"}`} ></i>
                    <i className={`fa fa-calendar globe ${langLocal === 'ar' ? "margin_right_20" : "margin_left_20"}`} onClick={() => setOpenCalendar(true)} ></i>
                    <i className={`fa fa-globe ${langLocal === 'ar' ? "margin_right_20" : "margin_left_20"}`} onClick={() => setlangPop(true)} ></i>
                    
                    <i className={`fa fa-bell globe ${langLocal === 'ar' ? "margin_right_20" : "margin_left_20"}`} onClick={() => setNotify(true)}></i>

                    <div onClick={navigateToProfile} className={`nav-user-details ${langLocal === 'ar' ? "margin_right_10" : "margin_left_10"} `} >
                        <span>
                            {profileDetails?.email}
                            <h5>{profileDetails?.role}</h5>
                        </span>
                        {/* <i className={`fa fa-user globe ${langLocal === 'ar' ? "margin_right_20" : "margin_left_20"}`} ></i> */}
                        <img className={`  ${langLocal === 'ar' ? "margin_right_20" : "margin_left_20"}`} src={avatar}></img>
                    </div>
                    {langPop && (
                        <div className={langLocal == "ar" ? "lang langL" : "lang langR"} ref={domNode} >
                            <span
                                className={langLocal == "ar" ? "textAlignRight" : ""}
                                onClick={() => {
                                    i18n.changeLanguage("en");
                                    localStorage.setItem('pentalensLang', i18n.language);
                                }}
                            >
                                {t('english')}
                            </span>
                            <span
                                className={langLocal == "ar" ? "textAlignRight" : ""}
                                onClick={() => {
                                    
                                    i18n.changeLanguage("ar");
                                    localStorage.setItem('pentalensLang', i18n.language);
                                }}
                            >
                                {t('arabic')}
                            </span>
                        </div>
                    )}
                </div>
            </nav>
        </>
    )
}

export default Navbar;

